import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Button,
  Flex,
  SimpleGrid,
  useToast,
} from '@chakra-ui/react';
import { useSearch } from '../../../contexts/SearchContext';
import { getData } from '../../../utils/httpClient';
import DynamicTable from '../../../components/table/DynamicTable';
import { columnsDataInscriptions } from './variables/columnsDataInscriptions';

function CourseInscriptions() {
  const { searchQuery } = useSearch();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const rowsPerPage = 10;
  const toast = useToast();

  const latestRequestRef = useRef(0);

  const getInscriptions = async (searchData) => {
    const requestId = ++latestRequestRef.current;
    try {
      const response = await getData(
        `/student-courses?page=${page + 1}&limit=${rowsPerPage}&data=${searchData}`,
      );
      if (requestId !== latestRequestRef.current) return;
      setData(response?.payload?.inscriptions || []);
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      if (requestId !== latestRequestRef.current) return;
      toast({
        title: 'Error al obtener inscripciones',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getInscriptions(searchQuery);
  }, [page, searchQuery]);

  return (
    <Box>
      <Flex justify="flex-end" mb={4}>
        <Button colorScheme="blue">
          Nueva Inscripción
        </Button>
      </Flex>
      
      <SimpleGrid mb="20px" columns={{ sm: 1 }} spacing={{ base: '20px', xl: '20px' }}>
        <DynamicTable
          columnsData={columnsDataInscriptions}
          data={data}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          showRowInfo={false}
        />
      </SimpleGrid>
    </Box>
  );
}

export default CourseInscriptions;
